export class Factura {
    BILL_ID: number;
    BILL_STATUS_ID: number;
    CREATION_DATE: Date;
    BILL_NUMBER: string; // FA0000001
    TOTAL_IVA: number;
	TOTAL_TAX: number; // RETENCION
	SUBTOTAL_BEFORE_TAX: number; // ANTES DE IMPUESTO
	CUSTOMER_ID: number; // CLIENTE DE LA VENTA
	CUSTOMER_NAME: string; // precargado editable
	CUSTOMER_RFC: string; // precargado editable
	ORGANIZATION_ID: number; // ar_organization
	RECEIVER_PAYMENT_FORM_ID: number; 
	RECEIVER_PAYMENT_METHOD_ID: number;
	RECEIVER_CFDI_USE_ID: number;
	INVOICE_TYPE : string;
	TAX_REGIME_ID: number; // regimenFiscal
	CANCELLED_BY: number; // sys_user
	CANCELLATION_DATE: Date;
	CURRENCY: string;
	IVA_FACTOR: number;
	COMMENTS: string;
	idDocuments: string;
	TOTAL: number;
	FECHA: string;
	FDFactura: Date;
	PAYMENT_DATE:string;
	TipoFactura:boolean;
	// ProductTYPE:string;
	BILL_CARTA_PORTE_ID: number;
	Total_ImpuestosRetenidos: number; // RETENCION
	// Sustitución / CFDI Relacionados (TipoRelacion 04)
	RELATION_TYPE_SAT_ID?: number;
	FacturaDocumentos?: Array<FacturaDocumento>; // {BILL_ID, UUID} de las facturas previas sustituidas
	FacturaIdDocumentos?: Array<number>;         // BILL_ID seleccionados en el modal
	Documentos?: Array<FacturaDocumento>;        // payload enviado al back (addFactura/updateFactura)
}

export class FacturaDocumento {
	BILL_ID: number;        // factura previa relacionada
	RELATED_BILL_ID?: number;
	UUID: string;           // UUID de la factura previa
}

export interface motivoDeCancelacion {
	idCancelacion: string;
	description: string;
}


// WEBPACK FOOTER //
// ./src/app/models/factura.ts